import { useSelector } from "react-redux";
import EndorsementsList from "../../../../components/Training/Endorsement/EndorsementsList";
import AlertCard from "../../../../components/Training/common/AlertCard";
import LayoutProvider from "../../../../providers/LayoutProvider";
import "./style.scss";
import { FaCircleInfo } from "react-icons/fa6";
import { FiX } from "react-icons/fi";
import { getEndorsements, getEndorsementsFromApi, getEndorsementsTotalCount, setEndorsements } from "../../../../store/slices/endorsement.slice";
import { useDispatch } from "react-redux";
import { getUser } from "../../../../store/slices/auth-slice";
import React, { useEffect, useState } from "react"
import { Toaster } from "react-hot-toast";
import { ROLES } from "../../../../constants";
import InfiniteScroll from 'react-infinite-scroll-component'

function Endorsement() {
  const endorsements = useSelector(getEndorsements)
  const totalCount = useSelector(getEndorsementsTotalCount)
  const totalPages = useSelector(getEndorsementsTotalCount)

  const [perPage, setPerPage] = useState(10)
  const [page, setPage] = useState(1)
  const [query, setQuery] = useState('')
  const [loading, setLoading] = useState(false)

  const user = useSelector(getUser)
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(setEndorsements([]))
  }, [dispatch])

  React.useEffect(() => {
    if (user?.role === ROLES.STUDENT) {
      setLoading(true)
      dispatch(getEndorsementsFromApi({ page, per_page: perPage, query }))
      setLoading(false)
    }
  }, [dispatch, perPage, page])

  return (
    <LayoutProvider classNames="endorsement_page">
      <Toaster />
      <h1 className="heading2">Endorsement</h1>
      <AlertCard
        title="Add New Endorsements"
        text="An endorsement attests to the completion of ground and/or flight training required for specific operating privileges or for airman certification testing."
        link="create"
      />
      {user?.role === ROLES.STUDENT && <>
        <h2 className="heading2 my-3">Your Endorsement</h2>
        {!endorsements?.length ? <div className="alert alert-warning my-4 d-flex align-items-center justify-content-between  py-2">
          <div className="d-flex align-items-center gap-2 p-0 m-0">
            <FaCircleInfo />
            <div className="fw-semibold">There are no existing endorsements to display. Please add your endorsement above</div>
          </div>
          <div className="close_icon" role="button">
            <FiX />
          </div>
        </div> : null}
        <InfiniteScroll
          dataLength={endorsements?.length}
          loader={loading}
          next={() => {
            setPage((prev) => prev + 1)
          }}
          hasMore={page < totalPages}
          style={{ overflowX: "hidden" }}
        >
          <EndorsementsList endorsements={endorsements} />
        </InfiniteScroll>
      </>}
    </LayoutProvider>
  );
}

export default Endorsement;
